import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const headingStyle = css`
  font-size: ${theme.fontSize(16)};
`;

export const dropzoneStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 110px;
  background-color: ${theme.colors.neutral5};
  margin-top: ${theme.spacing(1)};
  border-radius: ${theme.borderRadius.small};
  border: 1px dashed ${theme.colors.neutral20};
  padding: ${theme.spacing(2)};
`;

export const clickToUploadStyle = css`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const spacingFix = css`
  margin-bottom: ${theme.spacing(1)};
`;
